'use client';

import { UserNavbarAvatar } from '@govinity/ui/components/blocks/navbar';
import { type AuthenticatedUserResponse } from '@govinity/validation';
import { useAuthStore } from '@/stores/authStore';

export const NavbarUserAvatar = ({ user: serverSideUser }: { user: AuthenticatedUserResponse }) => {
  const loggedInUser = useAuthStore((state) => state.user);
  const user = loggedInUser || serverSideUser;

  return <UserNavbarAvatar user={user} />;
};
